// extracted by mini-css-extract-plugin
module.exports = {"VideoContainer":"VideoContainer_VideoContainer__jjWVX","isEven":"VideoContainer_isEven__6HpVw"};